import React, { useEffect } from 'react';
import '../assets/css/header-footer.css';
import '../../services/layoutService';
import { getHeader } from '../../services/layoutService';
const Header = props => {
  useEffect(() => {
    getHeader(props.sessionData?.countryId, props.sessionData?.language);
  }, [props.sessionData?.language]);
  return (
    <>
      <header id="header" className="ph-header-main"></header>
    </>
  );
};

export default Header;
